module.exports = __webpack_public_path__ + "img/about-panda.74946037.png";